import { jsxs, jsx } from 'react/jsx-runtime';
import { useLocalization } from '@shared-ui/localization-context';
import { EGDSButtonSize } from '../../button/button/index.esm.js';
import 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import '../../button/paging-button/index.esm.js';
import { EGDSOverlayButton } from '../../button/overlay-button/index.esm.js';
import { EGDSIcon, EGDSIconSize } from '../../icons/icon/index.esm.js';
import '../../layout-position/types/index.esm.js';
import { EGDSLayoutPosition } from '../../layout-position/layout-position/index.esm.js';
import { EGDSScrim } from '../../scrim/scrim/index.esm.js';
import { EGDSScrimType } from '../../scrim/types/index.esm.js';
import { PlayerState } from '../types/index.esm.js';
import styles from '../../styles/uitk-egds-video.css';
import { classNames } from '../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const EGDSVideoLayerControls = ({
  className,
  controls,
  playerState,
  buttonText
}) => {
  const l10n = useLocalization();
  const playPauseControls = () => playerState === PlayerState.PLAYING ? controls.pause : controls.play;
  const playPauseText = () => {
    if (playerState === PlayerState.PLAYING) {
      return buttonText?.pauseButton ?? l10n.formatText('video.pauseButton.label');
    }
    return buttonText?.playButton ?? l10n.formatText('video.playButton.label');
  };
  const shouldHideControls = [PlayerState.BUFFERING, PlayerState.PLAYING, PlayerState.PAUSED, PlayerState.UNSTARTED].includes(playerState);
  return jsxs("div", {
    className: getClassNameList(className),
    children: [playerState === PlayerState.UNSTARTED ? jsx(EGDSScrim, {
      type: EGDSScrimType.OVERLAY
    }) : null, jsx("button", {
      type: "button",
      "aria-label": playPauseText(),
      className: getClassNameList('uitk-video-layer-controls-link', {
        'uitk-video-hide-controls': shouldHideControls
      }),
      onClick: playPauseControls(),
      children: jsx("span", {
        className: getClassNameList('uitk-video-hide-controls'),
        children: playPauseText()
      })
    }), jsx(EGDSLayoutPosition, {
      type: "absolute",
      position: {
        top: 'center',
        left: 'center'
      },
      className: getClassNameList('uitk-video-play-button-wrapper'),
      children: jsx(EGDSOverlayButton, {
        "aria-hidden": "true",
        tabIndex: -1,
        onClick: playPauseControls(),
        size: EGDSButtonSize.LARGE,
        className: getClassNameList({
          'uitk-video-hide-controls': shouldHideControls
        }),
        children: jsx(EGDSIcon, {
          id: "play",
          name: "play_arrow",
          size: EGDSIconSize.LARGE,
          title: playPauseText()
        })
      })
    })]
  });
};
export { EGDSVideoLayerControls };